import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const SwitchHorizontalIcon = createIcon({
  displayName: 'SwitchHorizontalIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      d="M11.3333 2.66675L14 5.33341L11.3333 8.00008V6.00008H8.66667V4.66675H11.3333V2.66675ZM6.66667 4.66675C6.3 4.66675 6 4.96675 6 5.33341C6 5.70008 6.3 6.00008 6.66667 6.00008C7.03333 6.00008 7.33333 5.70008 7.33333 5.33341C7.33333 4.96675 7.03333 4.66675 6.66667 4.66675ZM4 4.66675C3.63333 4.66675 3.33333 4.96675 3.33333 5.33341C3.33333 5.70008 3.63333 6.00008 4 6.00008C4.36667 6.00008 4.66667 5.70008 4.66667 5.33341C4.66667 4.96675 4.36667 4.66675 4 4.66675ZM4.66667 11.3334H7.33333V10.0001H4.66667V8.00008L2 10.6667L4.66667 13.3334V11.3334ZM9.33333 11.3334C9.7 11.3334 10 11.0334 10 10.6667C10 10.3001 9.7 10.0001 9.33333 10.0001C8.96667 10.0001 8.66667 10.3001 8.66667 10.6667C8.66667 11.0334 8.96667 11.3334 9.33333 11.3334ZM12 11.3334C12.3667 11.3334 12.6667 11.0334 12.6667 10.6667C12.6667 10.3001 12.3667 10.0001 12 10.0001C11.6333 10.0001 11.3333 10.3001 11.3333 10.6667C11.3333 11.0334 11.6333 11.3334 12 11.3334Z"
      fill="currentColor"
    />
  ),
})
